import { makeStyles } from '@material-ui/core/styles';

interface Props {
  colorIcon?: string;
}

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(18),
  },

  wrapperColors: {
    display: 'grid',
    gridAutoFlow: 'column',
  },

  radioRoot: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },

  radioIcon: {
    borderRadius: '50%',
    width: 40,
    height: 40,
    border: `1px solid ${theme.palette.darkGrey[15]}`,
    backgroundColor: (props: Props) => `#${props.colorIcon}`,
  },

  radioChecked: {
    outline: '1px solid #000',
    outlineOffset: 8,
  },
}));

export default useStyles;
